export default __webpack_public_path__ + "static/media/R5C_8042.0af645e1.jpg";